import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/inventario_productos/getComprasRecientesProductoByUnidad.php';

export default function getComprasRecientesProductoByUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}